export enum FilterOptionType {
  Text = "text",
  Date = "date",
  ComboBox = "comboBox",
  CheckBox = "checkBox",
  Number = "number",
}
